import React from 'react';

import { styled } from '@mui/system';

import Typography from '@ui/Typography';

const Text = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));

const P = ({ children, ...rest }) => {
    return (
        <Text variant="body1" gutterBottom {...rest}>
            {children}
        </Text>
    );
};

export default P;
